// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Directory } from '../models';
import { ErrorResponse } from '../models';
import { FileCreate } from '../models';
import { FileDiskSpace } from '../models';
import { FileDiskSpaceUpdate } from '../models';
import { FileItem } from '../models';
import { FileList } from '../models';
import { Folder } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * CompanyFileApi - axios parameter creator
 * @export
 */
export const CompanyFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete company\'s file.
         * @param {string} id 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, fileId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/company/{id}/file/{fileId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update company disk space (in bytes).
         * @param {string} id 
         * @param {FileDiskSpaceUpdate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling companyUpdateDisk.');
            }
            const localVarPath = `/v1/company/{id}/disk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create folder.
         * @param {string} folder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folder: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError('folder','Required parameter folder was null or undefined when calling createFolder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createFolder.');
            }
            const localVarPath = `/v1/company/{id}/folder/create`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete folder.
         * @param {string} folder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folder: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError('folder','Required parameter folder was null or undefined when calling deleteFolder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteFolder.');
            }
            const localVarPath = `/v1/company/{id}/folder/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s directory.
         * @param {string} id 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directory(id: string, folder?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling directory.');
            }
            const localVarPath = `/v1/company/{id}/directory`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s free space on disk (in bytes).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disk(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling disk.');
            }
            const localVarPath = `/v1/company/{id}/disk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit file\'s name, description and folder.
         * @param {string} id 
         * @param {string} fileId 
         * @param {FileCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, fileId: string, body?: FileCreate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/company/{id}/file/{fileId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit folder.
         * @param {string} folder 
         * @param {string} newFolder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFolder(folder: string, newFolder: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError('folder','Required parameter folder was null or undefined when calling editFolder.');
            }
            // verify required parameter 'newFolder' is not null or undefined
            if (newFolder === null || newFolder === undefined) {
                throw new RequiredError('newFolder','Required parameter newFolder was null or undefined when calling editFolder.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editFolder.');
            }
            const localVarPath = `/v1/company/{id}/folder/edit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (newFolder !== undefined) {
                localVarQueryParameter['newFolder'] = newFolder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get single company\'s file.
         * @param {string} id 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, fileId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling get.');
            }
            const localVarPath = `/v1/company/{id}/file/{fileId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s file list by filter.
         * @param {string} id 
         * @param {Array<string>} [ids] 
         * @param {string} [ownerId] 
         * @param {string} [name] 
         * @param {string} [folder] 
         * @param {Date} [uploadedAtMin] 
         * @param {Date} [uploadedAtMax] 
         * @param {string} [mimeType] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'uploadedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(id: string, ids?: Array<string>, ownerId?: string, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling list.');
            }
            const localVarPath = `/v1/company/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (uploadedAtMin !== undefined) {
                localVarQueryParameter['uploadedAtMin'] = (uploadedAtMin as any).toISOString();
            }

            if (uploadedAtMax !== undefined) {
                localVarQueryParameter['uploadedAtMax'] = (uploadedAtMax as any).toISOString();
            }

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload company\'s file.
         * @param {string} id 
         * @param {string} fileName 
         * @param {any} file 
         * @param {string} [description] 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(id: string, fileName: string, file: any, description?: string, folder?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling upload.');
            }
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling upload.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling upload.');
            }
            const localVarPath = `/v1/company/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (folder !== undefined) { 
                localVarFormParams.append('folder', folder as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyFileApi - functional programming interface
 * @export
 */
export const CompanyFileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete company\'s file.
         * @param {string} id 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, fileId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration)._delete(id, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update company disk space (in bytes).
         * @param {string} id 
         * @param {FileDiskSpaceUpdate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).companyUpdateDisk(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create folder.
         * @param {string} folder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folder: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).createFolder(folder, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete folder.
         * @param {string} folder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folder: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).deleteFolder(folder, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get company\'s directory.
         * @param {string} id 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directory(id: string, folder?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Directory> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).directory(id, folder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get company\'s free space on disk (in bytes).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disk(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDiskSpace> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).disk(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit file\'s name, description and folder.
         * @param {string} id 
         * @param {string} fileId 
         * @param {FileCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, fileId: string, body?: FileCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileItem> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).edit(id, fileId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit folder.
         * @param {string} folder 
         * @param {string} newFolder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFolder(folder: string, newFolder: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).editFolder(folder, newFolder, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get single company\'s file.
         * @param {string} id 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, fileId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileItem> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).get(id, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get company\'s file list by filter.
         * @param {string} id 
         * @param {Array<string>} [ids] 
         * @param {string} [ownerId] 
         * @param {string} [name] 
         * @param {string} [folder] 
         * @param {Date} [uploadedAtMin] 
         * @param {Date} [uploadedAtMax] 
         * @param {string} [mimeType] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'uploadedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(id: string, ids?: Array<string>, ownerId?: string, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileList> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).list(id, ids, ownerId, name, folder, uploadedAtMin, uploadedAtMax, mimeType, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload company\'s file.
         * @param {string} id 
         * @param {string} fileName 
         * @param {any} file 
         * @param {string} [description] 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(id: string, fileName: string, file: any, description?: string, folder?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileItem> {
            const localVarAxiosArgs = CompanyFileApiAxiosParamCreator(configuration).upload(id, fileName, file, description, folder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CompanyFileApi - factory interface
 * @export
 */
export const CompanyFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete company\'s file.
         * @param {string} id 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, fileId: string, options?: any) {
            return CompanyFileApiFp(configuration)._delete(id, fileId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update company disk space (in bytes).
         * @param {string} id 
         * @param {FileDiskSpaceUpdate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options?: any) {
            return CompanyFileApiFp(configuration).companyUpdateDisk(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @summary Create folder.
         * @param {string} folder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folder: string, id: string, options?: any) {
            return CompanyFileApiFp(configuration).createFolder(folder, id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Delete folder.
         * @param {string} folder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folder: string, id: string, options?: any) {
            return CompanyFileApiFp(configuration).deleteFolder(folder, id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get company\'s directory.
         * @param {string} id 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directory(id: string, folder?: string, options?: any) {
            return CompanyFileApiFp(configuration).directory(id, folder, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get company\'s free space on disk (in bytes).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disk(id: string, options?: any) {
            return CompanyFileApiFp(configuration).disk(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Edit file\'s name, description and folder.
         * @param {string} id 
         * @param {string} fileId 
         * @param {FileCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, fileId: string, body?: FileCreate, options?: any) {
            return CompanyFileApiFp(configuration).edit(id, fileId, body, options)(axios, basePath);
        },
        /**
         * 
         * @summary Edit folder.
         * @param {string} folder 
         * @param {string} newFolder 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFolder(folder: string, newFolder: string, id: string, options?: any) {
            return CompanyFileApiFp(configuration).editFolder(folder, newFolder, id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get single company\'s file.
         * @param {string} id 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, fileId: string, options?: any) {
            return CompanyFileApiFp(configuration).get(id, fileId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get company\'s file list by filter.
         * @param {string} id 
         * @param {Array<string>} [ids] 
         * @param {string} [ownerId] 
         * @param {string} [name] 
         * @param {string} [folder] 
         * @param {Date} [uploadedAtMin] 
         * @param {Date} [uploadedAtMax] 
         * @param {string} [mimeType] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'uploadedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(id: string, ids?: Array<string>, ownerId?: string, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options?: any) {
            return CompanyFileApiFp(configuration).list(id, ids, ownerId, name, folder, uploadedAtMin, uploadedAtMax, mimeType, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @summary Upload company\'s file.
         * @param {string} id 
         * @param {string} fileName 
         * @param {any} file 
         * @param {string} [description] 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(id: string, fileName: string, file: any, description?: string, folder?: string, options?: any) {
            return CompanyFileApiFp(configuration).upload(id, fileName, file, description, folder, options)(axios, basePath);
        },
    };
};

/**
 * CompanyFileApi - object-oriented interface
 * @export
 * @class CompanyFileApi
 * @extends {BaseAPI}
 */
export class CompanyFileApi extends BaseAPI {
    /**
     * 
     * @summary Delete company\'s file.
     * @param {string} id 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public _delete(id: string, fileId: string, options?: any) {
        return CompanyFileApiFp(this.configuration)._delete(id, fileId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update company disk space (in bytes).
     * @param {string} id 
     * @param {FileDiskSpaceUpdate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public companyUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options?: any) {
        return CompanyFileApiFp(this.configuration).companyUpdateDisk(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Create folder.
     * @param {string} folder 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public createFolder(folder: string, id: string, options?: any) {
        return CompanyFileApiFp(this.configuration).createFolder(folder, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Delete folder.
     * @param {string} folder 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public deleteFolder(folder: string, id: string, options?: any) {
        return CompanyFileApiFp(this.configuration).deleteFolder(folder, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get company\'s directory.
     * @param {string} id 
     * @param {string} [folder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public directory(id: string, folder?: string, options?: any) {
        return CompanyFileApiFp(this.configuration).directory(id, folder, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get company\'s free space on disk (in bytes).
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public disk(id: string, options?: any) {
        return CompanyFileApiFp(this.configuration).disk(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Edit file\'s name, description and folder.
     * @param {string} id 
     * @param {string} fileId 
     * @param {FileCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public edit(id: string, fileId: string, body?: FileCreate, options?: any) {
        return CompanyFileApiFp(this.configuration).edit(id, fileId, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Edit folder.
     * @param {string} folder 
     * @param {string} newFolder 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public editFolder(folder: string, newFolder: string, id: string, options?: any) {
        return CompanyFileApiFp(this.configuration).editFolder(folder, newFolder, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get single company\'s file.
     * @param {string} id 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public get(id: string, fileId: string, options?: any) {
        return CompanyFileApiFp(this.configuration).get(id, fileId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get company\'s file list by filter.
     * @param {string} id 
     * @param {Array<string>} [ids] 
     * @param {string} [ownerId] 
     * @param {string} [name] 
     * @param {string} [folder] 
     * @param {Date} [uploadedAtMin] 
     * @param {Date} [uploadedAtMax] 
     * @param {string} [mimeType] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'name' | 'uploadedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public list(id: string, ids?: Array<string>, ownerId?: string, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options?: any) {
        return CompanyFileApiFp(this.configuration).list(id, ids, ownerId, name, folder, uploadedAtMin, uploadedAtMax, mimeType, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Upload company\'s file.
     * @param {string} id 
     * @param {string} fileName 
     * @param {any} file 
     * @param {string} [description] 
     * @param {string} [folder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFileApi
     */
    public upload(id: string, fileName: string, file: any, description?: string, folder?: string, options?: any) {
        return CompanyFileApiFp(this.configuration).upload(id, fileName, file, description, folder, options)(this.axios, this.basePath);
    }

}
